module.exports = __webpack_public_path__ + "media/images/admin/icons/upload-cloud-a94b24ba5b6a7231dce6185250df6bc1.svg";